import styles from "./preloader.component.module.css";
const Preloader = () => {
  return (
    <div className={styles.container}>
      <span className="loading loading-ring loading-lg"></span>
    </div>
  );
};

export default Preloader;
